import React from 'react';

import Autocomplete from '../inputs/Autocomplete';
import { createFilterOptions } from '@mui/material/useAutocomplete';

import useSellers from '../../hooks/sellers/useSellers';

const SellerAutocomplete = ({ onChange, value }) => {
    const { sellers, loading: loadingSellers, setTextField } = useSellers();
    let timerId;

    const onInputChange = (event, value) => {
        if (sellers.findIndex(s => s.userName === value || s.code === value) > -1)
            return;

        clearTimeout(timerId)
        timerId = setTimeout(() => setTextField(value), 500);
    }

    return (
        <Autocomplete
            name='seller'
            fullWidth
            loading={loadingSellers}
            loadingText='Buscando vendedores...'
            options={sellers || []}
            value={value || ''}
            onInputChange={onInputChange}
            onChange={(e, value) => onChange(value)}
            getOptionLabel={option => option ? `(${option.code}) ${option.userName}` : ''}
            isOptionEqualToValue={(option, value) => option?.id === value.id}
            filterOptions={createFilterOptions({
                stringify: (option) => option.userName + option.code
            })}
            TextProps={{
                required: true,
                label: 'Vendedor',
                helperText: 'Buscar por nombre o código',
                autoFocus: true,
            }}
            renderOption={(props, option) => (
                <li {...props}>
                    <span>{`(${option.code}) ${option.userName}`}</span>
                </li>)}
        />
    );
}

export default SellerAutocomplete;